import { useEffect, useState } from "react";
import SearchBar from "./SearchBar";
import ProjectModal from "./Modal/ProjectModal";

function Dashboard() {
  const [toggleModal, setToggleModal] = useState<boolean>(false);

  function modalHandler(bool: boolean) {
    if (bool === true) {
      setToggleModal(bool);
      const message = {
        type: "EXPAND_IFRAME",
      };
      window.parent.postMessage(message, window.location.origin);
    }
    if (bool === false) {
      setToggleModal(bool);
      // Send a message to the parent window (Magento) to shrink the iframe
      const message = {
        type: "SHRINK_IFRAME",
      };
      window.parent.postMessage(message, window.location.origin);
    }
  }

  return (
    <>
      <div className="container mt2" style={{ maxWidth: "1140px" }}>
        <div className="text-left">
          <div>
            <button
              onClick={() => modalHandler(true)}
              className="orange-button"
            >
              START
            </button>
          </div>
        </div>
      </div>
      {toggleModal ? (
        <>
          <ProjectModal
            toggleModal={toggleModal}
            setToggleModal={modalHandler}
          />
          <div className="modal-backdrop fade in"></div>
        </>
      ) : null}
    </>
  );
}

export default Dashboard;
